import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { List } from 'antd-mobile';
import { createUseStyles } from 'react-jss'

import { LightBox } from 'react-lightbox-pack';
import "react-lightbox-pack/dist/index.css";

import moment from 'moment-timezone';
import 'moment/locale/ru';
import { CollectionServerMobile, QueryDetail, QueryOrder, useAuth, useNavigation, useUserContext } from 'fennec-ui';

import "./index.css"
import { eventModelActions } from '../Event';

const useStyles = createUseStyles({
    button: {
        marginLeft: "10px"
    },
    fieldName: {
        fontWeight: "300",
        fontSize: "13px"
    },
    fieldValue: {
        fontStyle: "italic",
        color: "black",
        fontWeight: "300",
        fontSize: "14px"
    }
})

const Item = List.Item;

const Playbill = ({ data }) => {
    const auth = useAuth();
    let arr = [...data];
    const [toggle, setToggle] = React.useState(false);
    const [sIndex, setSIndex] = React.useState(0);
    var bucketName = "federation"
    if (auth.appProfile != "prod") {
        bucketName = "federation-dev"
    }
    // Handler
    const lightBoxHandler = (state, sIndex) => {
        setToggle(state);
        setSIndex(sIndex);
    };

    arr.sort((a, b) => b.sort - a.sort);
    if (arr.length >= 1) {
        let ssilka = arr[0].ssilka;
        if (arr[0].ssilkaMin) {
            ssilka = arr[0].ssilkaMin
        }
        return <div className="event-lightbox">
            <img
                onClick={(e) => {
                    e.stopPropagation();
                    lightBoxHandler(true, 0);
                }}
                style={{ width: "100%", height: "100%" }}
                src={"https://storage.yandexcloud.net/" + bucketName + "/" + ssilka}
            />
            <LightBox
                state={toggle}
                event={lightBoxHandler}
                data={data.map((e, idx) => {
                    return {
                        "id": idx,
                        "image": "https://storage.yandexcloud.net/" + bucketName + "/" + e.ssilka,
                    }
                })}
                imageWidth="100vw"
                imageHeight="100vh"
                thumbnailHeight={78}
                thumbnailWidth={78}
                setImageIndex={setSIndex}
                imageIndex={sIndex}
            />
        </div>;
    }
    return <div style={{
        width: "100%",
        height: "100%",
        backgroundColor: "#f7f7f7",
        opacity: "0.8",
        backgroundImage: "repeating-linear-gradient(45deg, #dddddd 25%, transparent 25%, transparent 75%, #dddddd 75%, #dddddd), repeating-linear-gradient(45deg, #dddddd 25%, #f7f7f7 25%, #f7f7f7 75%, #dddddd 75%, #dddddd)",
        backgroundPosition: "0 0, 5px 5px",
        backgroundSize: "10px 10px",
    }}></div>;
};
export default function EventBlock(props) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const navigation = useNavigation();
    const auth = useAuth();
    const { history, source, create, context, base, sourceKey } = props;
    const [loading, setLoading] = useState(false);
    const user = useUserContext();
    const sameDay = (start, end) => {
        var mstart = moment(start);
        var mend = moment(end);
        var year1 = mstart.year(), month1 = mstart.month(), day1 = mstart.date();
        var day1n = mstart.add(24, 'hour')
        var year2 = mend.year(), month2 = mend.month(), day2 = mend.date();
        var hour2 = mend.hour();
        if (year1 == year2 && month1 == month2 && ((day2 == day1) || (day2 == day1n && hour2 < 8))) {
            return true
        }
        return false
    };
    const filters = React.useCallback(() => [
        {
            label: "Дата начала",
            name: "nachaloSorevnovaniya",
            type: "date",
            filterType: "range",
            sort: true,
            filter: true,

            sorted: "ASC",
            filtered: [moment().subtract(5, "days"), moment().add(1, "years")],
        },
        {   // Тип мероприятия
            label: "Тип мероприятия",
            name: "tipMeropriyatiya",
            filterType: "group",
            display: (o) => o.opisanie,
            sort: true,
            filter: true
        },
        {   // Уровень мероприятия
            label: "Уровень мероприятия",
            name: "urovenMeropriyatiya",
            filterType: "group",
            display: (o) => o.opisanie,
            sort: true,
            filter: true
        },
        {   // Место проведения
            label: "Место проведения",
            name: "mestoProvedeniya",
            filterType: "group",
            display: (o) => o.name,
            queryFilter: [
                QueryDetail("none"),
                QueryOrder("name", "ASC")
            ],
            sort: true,
            filter: true
        },
    ], []);

    return (
        <>
            <CollectionServerMobile
                noheader={true}
                auth={auth}
                name={"Meropriyatiya"}
                source={source}
                filters={filters}
                size={"small"}
                mode={"list"}
                render={(e, idx, options) => {
                    const kategorii = (data) => {
                        let result = [];
                        let mResult = new Map();
                        if (data) {
                            for (let idx = 0; idx < data.length; idx++) {
                                const item = data[idx];
                                let kat = mResult.get(item.tantsevalnayaDistsiplinaID);
                                if (!kat) {
                                    kat = {
                                        tantsevalnayaDistsiplina: item.tantsevalnayaDistsiplina,
                                        kategoriiUchastnikov: [],
                                        mKategoriiUchastnikov: new Map(),
                                    }
                                    mResult.set(item.tantsevalnayaDistsiplinaID, kat);
                                    result.push(kat);
                                }
                                let ok = kat.mKategoriiUchastnikov.get(item.kategoriyaUchastnikovID);
                                if (!ok) {
                                    kat.mKategoriiUchastnikov.set(item.kategoriyaUchastnikovID, data[idx].kategoriyaUchastnikov)
                                    kat.kategoriiUchastnikov.push(data[idx].kategoriyaUchastnikov);
                                }
                            }
                        }

                        for (let idx = 0; idx < result.length; idx++) {
                            result[idx].kategoriiUchastnikov.sort((a, b) => a.ID - b.ID);
                        }

                        result.sort((a, b) => a.tantsevalnayaDistsiplina.ID - b.tantsevalnayaDistsiplina.ID);

                        return result
                    }
                    const kategoriiView = (e) => {
                        const list = kategorii(e.kategoriiUchastnikovNaMeropriyatiyakhMeropriyatie);
                        if (list.length <= 0) return <></>;
                        return (
                            <div key="q4" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
                                <div className={classes.fieldName}>Категории:</div>
                                <ul style={{ listStyle: "none", paddingInlineStart: "2px", fontSize: "13px" }}>
                                    {list.map((kat, i) => {
                                        return <li key={i}>
                                            {kat.tantsevalnayaDistsiplina.nazvanie + " "}
                                            ({
                                                kat.kategoriiUchastnikov.map((itemD, idx) => {
                                                    if (idx + 1 < kat.kategoriiUchastnikov.length) {
                                                        return <span key={idx}>{itemD.nazvanie + ", "}</span>
                                                    } else {
                                                        return <span key={idx}>{itemD.nazvanie}</span>
                                                    }
                                                })
                                            })
                                        </li>
                                    })}
                                </ul>
                            </div>
                        );
                    };
                    return (
                        <div key={idx} style={{ padding: "10px 0px" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", gap:"10px" }}>
                                <div style={{ maxWidth: "78px" }}>
                                    <div style={{ width: "78px", height: "78px", overflow: "hidden", borderRadius: "6px" }}>
                                        <Playbill auth={auth} data={(e?.ssilkiNaFailiMeropriyatie) ? [...e?.ssilkiNaFailiMeropriyatie?.filter(e => e.tipSsilkiID === 7)] : []} />
                                    </div>
                                    <div style={{ marginTop: "7px" }}>
                                        <div style={{
                                            backgroundColor: "#eaeaea",
                                            fontSize: "14px",
                                            fontWeight: "400",
                                            color: "black",
                                            borderRadius: "6px",
                                            textAlign: "center",
                                            padding: "0 7px",
                                            textAlign: "center",
                                        }}>
                                            <div style={{
                                                borderRadius: "5px",
                                                backgroundColor: "#f6214b",

                                                fontSize: "12px",
                                                fontWeight: "600",
                                                color: "white",
                                                margin: "0 -7px",
                                                boxShadow: "0px 6px 5px -5px rgb(34 60 80 / 60%",
                                                padding: "3px 7px"
                                            }}>
                                                {moment(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}
                                                {/* {true === sameDay(e.nachaloSorevnovaniya, e.okonchanieSorevnovaniya) &&
                                                    moment(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')
                                                }
                                                {true !== sameDay(e.nachaloSorevnovaniya, e.okonchanieSorevnovaniya) &&
                                                    <>
                                                        <div style={{ fontSize: "16px" }}>
                                                            {moment(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD')}
                                                            -
                                                            {moment(e.okonchanieSorevnovaniya).tz("Europe/Moscow").format('DD')}
                                                        </div>
                                                        <div style={{ fontSize: "14px" }}>
                                                            {moment(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('MMMM')} {moment(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('YYYY')}
                                                        </div>
                                                    </>
                                                } */}
                                            </div>
                                            <div style={{
                                                fontSize: "10px",
                                                fontWeight: "400",
                                                padding: "0px"
                                            }}>
                                                {moment(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
                                                {/* {true === sameDay(e.nachaloSorevnovaniya, e.okonchanieSorevnovaniya) && <>
                                                    {moment(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
                                                </>}
                                                {true !== sameDay(e.nachaloSorevnovaniya, e.okonchanieSorevnovaniya) && <>
                                                    {moment(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
                                                    <span> - </span>
                                                    {moment(e.okonchanieSorevnovaniya).tz("Europe/Moscow").format('dddd')}
                                                </>} */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ flex: "auto" }}>
                                    <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
                                        <span className={classes.fieldValue} style={{ fontWeight: "600" }}>
                                        <a href={`/fed/event/${e.ID}`}>{e.nazvanieMeropriyatiya}</a>
                                            </span>
                                    </div>
                                    <div key="q2" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
                                        <span className={classes.fieldName}>Уровень: </span><span className={classes.fieldValue}>{e.urovenMeropriyatiya.opisanie}</span>
                                    </div>
                                    <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
                                        <span className={classes.fieldName}>Место проведения: </span>
                                        <span className={classes.fieldValue}>{e.mestoProvedeniya.name}</span>
                                    </div>
                                    {kategoriiView(e)}
                                </div>
                            </div>
                        </div>
                    )
                }}
                modelActionsTitle={(item) => ({
                    header: "Мероприятие",
                    subheader: (item) ? item.nazvanieMeropriyatiya : "",
                })}
                modelActions={(item) => {
                    return eventModelActions(auth, navigation, user, dispatch, item, create, base, sourceKey)
                }}
            />
        </>
    );
}

// EventBlock.whyDidYouRender = true
// CollectionServerMobile.whyDidYouRender = true